export default {

  transportList: (state) => {
    return state.transportList;
  },
  transportDetails: (state) => {
    return state.transportDetails;
  },

  gifts: (state) => {
    return state.gifts;
  },
  foodList: (state) => {
    return state.foodList;
  },
  calendarList: (state) => {
    return state.calendarList;
  },


};
